import { ExecutionBriefsState, IExecutionBriefsState } from "../reducers/executionBriefsReducer";
import { INdaData } from "../../types/ndaData.interface";
import { loadingSelector } from "./loading";
import { createSelector } from "reselect";
import { RootState } from "../store";

export const getExecutionBriefState = (state: RootState): ExecutionBriefsState => {
  return state.executionBriefs;
};

export const selectExecutionBrief = createSelector(
  getExecutionBriefState,
  (state: ExecutionBriefsState) => state.data
);

export const selectExecutionBriefsErrors = ({ executionBriefs }: IExecutionBriefsState) =>
  executionBriefs.errors;
export const selectExecutionBriefFormErrors = ({ executionBriefs }: IExecutionBriefsState) =>
  executionBriefs.formErrors;

export const selectExecutionBriefNdaData = ({
  executionBriefs: {
    data: { isUnderNda, underNdaUserDetails },
  },
}: IExecutionBriefsState) => ({ isUnderNda, underNdaUserDetails } as INdaData);

export const selectExecutionBriefsResultCount = ({
  executionBriefs: { count },
}: IExecutionBriefsState) => count;

export const selectExecutionBriefsResults = ({
  executionBriefs: { results },
}: IExecutionBriefsState) => results;

export const selectExecutionBriefsOwners = ({
  executionBriefs: {
    filters: { briefOwners },
  },
}: IExecutionBriefsState) => briefOwners;

export const selectReviewers = ({
  executionBriefs: {
    data: { reviewers },
  },
}: IExecutionBriefsState) => reviewers;

const loadingStateSelector = ({ executionBriefs: { loading } }: IExecutionBriefsState) => loading;

export const executionBriefsLoadingSelector = loadingSelector(loadingStateSelector);

export const selectExecutionResourceType = ({
  executionBriefs: {
    data: { resourcetype },
  },
}: IExecutionBriefsState) => resourcetype;

export const selectExecutionName = ({
  executionBriefs: {
    data: { name },
  },
}: IExecutionBriefsState) => name;

export const selectBreadcrumbInfo = ({
  executionBriefs: {
    data: { breadcrumbInfo },
  },
}: IExecutionBriefsState) => (breadcrumbInfo ? breadcrumbInfo : null);

export const selectExecutionBriefStatus = ({
  executionBriefs: {
    data: { status },
  },
}: IExecutionBriefsState) => status;

export const selectExecutionBriefId = ({
  executionBriefs: {
    data: { id },
  },
}: IExecutionBriefsState) => id;

export const selectCampaignId = ({
  executionBriefs: {
    data: { campaignBriefId },
  },
}: IExecutionBriefsState) => campaignBriefId;

export const selectExecutionBriefOwnerId = ({
  executionBriefs: {
    data: {
      briefOwner: { id },
    },
  },
}: IExecutionBriefsState) => id;

export const selectExecutionBriefMerchOwnerDetails = ({
  executionBriefs: {
    data: { merchOwnerDetails },
  },
}: IExecutionBriefsState) => merchOwnerDetails;

export const selectExecutionBriefMerchOwners = ({
  executionBriefs: {
    data: { merchOwners },
  },
}: IExecutionBriefsState) => merchOwners;

export const selectExecutionBriefsInCampaignResults = ({
  executionBriefs: { results },
}: IExecutionBriefsState) => results;

export const selectExecBriefOwnerName = ({
  executionBriefs: {
    data: {
      briefOwner: { firstName, lastName },
    },
  },
}: IExecutionBriefsState) => `${firstName} ${lastName}`;

export const selectExecBriefUpdatedTime = ({
  executionBriefs: {
    data: { updatedAt },
  },
}: IExecutionBriefsState) => updatedAt;

export const selectExecutionBriefField = (field: string, defaultValue?: any) => (
  executionBriefs: IExecutionBriefsState
) => {
  return ((executionBriefs?.executionBriefs?.data ?? { [field]: defaultValue }) as any)[field];
};

export const selectExecutionBriefLoader = ({ executionBriefs }: IExecutionBriefsState) =>
  executionBriefs.loading;

export const selectHierarchyDetails = ({
  executionBriefs: {
    data: { hierarchyDetails },
  },
}: IExecutionBriefsState) => hierarchyDetails;
